import { ActionButtonProps, Box } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { forwardRef, useImperativeHandle } from 'react'
import * as React from 'react'

export interface SearchButtonProps extends ActionButtonProps {
  onProceedPress: () => void
  isLoading?: boolean
  ref: React.MutableRefObject<null>
  mid: string
  isValidDevice?: boolean
}

const SearchButton = forwardRef((props: SearchButtonProps, ref) => {
  const { onProceedPress } = props
  useImperativeHandle(ref, () => ({
    onPress: () => onPress(),
  }))

  const onPress = () => {
    onProceedPress()
  }

  const regex = /^[0-9]*$/
  const isValid = (props?.mid?.length === 15 && regex.test(props?.mid)) || !!props?.values?.deviceid
  return (
    <Box marginBottom={8} w={120}>
      <ButtonNew title={'Apply Filter'} onPress={onPress} type={'primary'} height={36} disabled={!isValid} />
    </Box>
  )
})

export default SearchButton
